var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 0.833252H6.33325C3.3 0.833252 0.833252 3.3 0.833252 6.33325V18.2499C0.833252 18.493 0.929829 18.7262 1.10174 18.8981C1.27365 19.07 1.5068 19.1666 1.74992 19.1666H13.6666C16.6998 19.1666 19.1666 16.6998 19.1666 13.6666V6.33325C19.1666 3.3 16.6998 0.833252 13.6666 0.833252ZM14.5833 10.9166H10.9166V14.5833H9.08325V10.9166H5.41659V9.08325H9.08325V5.41659H10.9166V9.08325H14.5833V10.9166Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddons);
export default __webpack_public_path__ + "static/media/addons.85c90257.svg";
export { ForwardRef as ReactComponent };